module.exports = __webpack_public_path__ + "static/logo-esrb-fr-CA-bbb84c3b077af63557bbf1ed37172c8e.png";